import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    firstNameLabel: 'First Name',
    lastNameLabel: 'Last Name',
    legalTitleLabel: 'Legal title',
  },
  fr: {
    firstNameLabel: 'Prénom',
    lastNameLabel: 'Nom',
    legalTitleLabel: 'Civilité',
  },
});
